<template>
	<sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh">
		<template slot="table-body">
			<gestione-attivita-tasks-list-component ref="cmpGestioneAttivitaTasksListComponent" @beforeLoadData="onBeforeLoadDataGestioneAttivitaTasksListComponentt" @afterLoadData="onAfterLoadDataGestioneAttivitaTasksListComponent"></gestione-attivita-tasks-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaTasksListComponent from "../components/GestioneAttivitaTasksListComponent.vue";
export default {
	components: { SaPageLayout, GestioneAttivitaTasksListComponent },
	data() {
		return {
			showModalLoading: false,
			linkedit: "tasks",
		};
	},
	mounted() {
		let me = this;
		me.$refs.cmpGestioneAttivitaTasksListComponent.init();
	},
	methods: {
		onBeforeLoadDataGestioneAttivitaTasksListComponentt() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadDataGestioneAttivitaTasksListComponent() {
			let me = this;
			me.showModalLoading = false;
		},
		onRefresh() {
			let me = this;
			me.$refs.cmpGestioneAttivitaTasksListComponent.init();
		},
	},
};
</script>

<style></style>
